/**
 * i18n Configuration
 * Centralized configuration for i18next
 */

export interface I18nConfig {
  fallbackLng: string;
  supportedLngs: string[];
  defaultNS: string;
  ns: string[];
  debug: boolean;
  interpolation: {
    escapeValue: boolean;
  };
}

export const i18nConfig: I18nConfig = {
  fallbackLng: 'en',
  supportedLngs: ['en', 'ua'],
  defaultNS: 'common',
  ns: ['common', 'validation', 'errors', 'auth'],
  debug: process.env.NODE_ENV === 'development',
  interpolation: {
    escapeValue: false, // React escapes by default
  },
};

export default i18nConfig;

